import { __decorate, __metadata } from "tslib";
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { OrderExposeGroup } from '../interface';
export class ListOrderDelayedInfoDto {
    constructor() {
        this.isASAP = true;
    }
}
__decorate([
    Expose({ groups: [OrderExposeGroup.LIST] }),
    ApiProperty({ type: () => Boolean, default: true }),
    __metadata("design:type", Boolean)
], ListOrderDelayedInfoDto.prototype, "isASAP", void 0);
__decorate([
    Expose({ groups: [OrderExposeGroup.LIST] }),
    ApiPropertyOptional({ type: () => Date, format: 'date-time', description: 'Orders later than date (UTC date)', example: '2020-04-23T17:45:00.000Z' }),
    __metadata("design:type", Date)
], ListOrderDelayedInfoDto.prototype, "date", void 0);
//# sourceMappingURL=ListOrderDelayedInfoDto.js.map